import React from 'react'

const ComingSoon = () => {
  return (
    <div className="row">
        <div className="col-lg-12">
            <div className="text-center mt-sm-5 pt-4 mb-4">
                <div className="mb-sm-5 pb-sm-4 pb-5">
                    <img src="/assets/images/comingsoon.png" alt="" height="120" className="move-animation" />
                </div>
                <div className="mb-5">
                    <h1 className="display-2 coming-soon-text">Coming Soon</h1>
                </div>
                <div>
                    <div className="row justify-content-center mt-5">
                        <div className="col-lg-8">
                            <div id="countdown" className="countdownlist"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ComingSoon
